import { ref, onMounted, watch } from "vue";

export function useModal(modalRef, open = false, onCloseCallback = null) {
  const isOpen = ref(open);
  const toggleModal = (open) => {
    if (modalRef.value) {
      open ? modalRef.value.$el.showModal() : modalRef.value.$el.close();
    }
  };
  const openModal = () => {
    isOpen.value = true;
  };
  const closeModal = () => {
    isOpen.value = false;
    if (onCloseCallback && typeof onCloseCallback === "function") {
      onCloseCallback();
    }
  };
  onMounted(() => {
    toggleModal(isOpen.value);
  });
  watch(
    () => isOpen.value,
    (value) => {
      toggleModal(value);
    }
  );
  window.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isOpen.value) {
      closeModal();
    }
  });
  return [openModal, closeModal, isOpen];
}
